<mat-tree #treeElement [dataSource]="dataSource" [treeControl]="treeControl">
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
    <button mat-icon-button disabled></button>
    <ng-container style="select-font" *ngIf="!node.allowSelection">{{node.displayValue}}</ng-container>
    <mat-checkbox style="select-font" *ngIf="node.allowSelection" [checked]="node.selectionState(_value) > TreeViewSelectionState.None" (change)="toggleSelection(node)">{{node.displayValue}}</mat-checkbox>
  </mat-tree-node>
  <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
    <button [disabled]="!node.expandable" mat-icon-button [attr.aria-label]="'Toggle ' + node.displayValue" matTreeNodeToggle>
      <mat-icon *ngIf="node.expandable" class="mat-icon-rtl-mirror">
        {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
      </mat-icon>
    </button>
    <ng-container *ngIf="!node.allowSelection">{{node.displayValue}}</ng-container>
    <mat-checkbox style="select-font" *ngIf="node.allowSelection" (click)="$event.stopPropagation()" [checked]="node.selectionState(_value) > TreeViewSelectionState.None" [indeterminate]="node.selectionState(_value) === TreeViewSelectionState.ChildSelected" (change)="toggleSelection(node)">{{node.displayValue}}</mat-checkbox>
    <mat-progress-bar *ngIf="node.isLoading" mode="indeterminate" class="tree-progress-bar"></mat-progress-bar>
  </mat-tree-node>
</mat-tree>
